export const DEFAULT_LANGUAGE = 'fa'
export const FALLBACK_LANGUAGE = 'en'
export const SUPPORTED_LANGUAGES = ['en', 'fa']